import { useEffect } from 'react';

interface KeyboardShortcut {
  key: string;
  metaKey?: boolean;
  ctrlKey?: boolean;
  altKey?: boolean;
  shiftKey?: boolean;
  preventDefault?: boolean;
}

export function useKeyboardShortcut(
  shortcut: KeyboardShortcut,
  callback: () => void
) {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const metaMatches = !shortcut.metaKey || event.metaKey;
      const ctrlMatches = !shortcut.ctrlKey || event.ctrlKey;
      const altMatches = shortcut.altKey ? event.altKey : !shortcut.altKey;
      const shiftMatches = shortcut.shiftKey
        ? event.shiftKey
        : !shortcut.shiftKey;

      const keyMatches =
        shortcut.key && event.key
          ? event.key.toLowerCase() === shortcut.key.toLowerCase()
          : false;

      if (
        keyMatches &&
        ((metaMatches && shortcut.metaKey) ||
          (ctrlMatches && shortcut.ctrlKey)) &&
        altMatches &&
        shiftMatches
      ) {
        if (shortcut.preventDefault) {
          event.preventDefault();
        }
        callback();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [callback, shortcut]);
}
